/**
 * Local replacement for google.maps.drawing.OverlayType.
 *
 * The "drawing" library is no longer loaded, so google.maps.drawing.OverlayType
 * is not available at runtime. Values mirror the Google Maps ones so shapes
 * remain interchangeable with anything still typed against the Maps API.
 */
export enum OverlayType {
    CIRCLE = 'circle',
    MARKER = 'marker',
    POLYGON = 'polygon',
    POLYLINE = 'polyline',
    RECTANGLE = 'rectangle'
}
